<template>
  <v-card height="100%" v-once>
    <v-card-title primary-title>
      <div class="headline">{{labels.fw}}</div>
    </v-card-title>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.fwTransNo}}</v-subheader>
            <div v-if="maid.fwTransNo">{{maid.fwTransNo}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.fwWPType}}</v-subheader>
            <div>{{workPermitType}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.fwWPNo}}</v-subheader>
            <div v-if="maid.fwWPNo">{{maid.fwWPNo}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.fwName}}</v-subheader>
            <div v-if="maid.fwName">{{maid.fwName}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.fwNationality}}</v-subheader>
            <div>{{nationality}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.fwPassport}}</v-subheader>
            <div v-if="maid.fwPassport">{{maid.fwPassport}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.fwDob}}</v-subheader>
            <div v-if="maid.fwDob">{{formatDisplayDate(maid.fwDob)}}</div>
            <div v-else>-</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.fwGender}}</v-subheader>
            <div>{{gender}}</div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { formatDisplayDate } from '@/utils/date'
import { gender } from '@/const/underwriting'
import { maidNationality, workPermitType } from '@/const/underwriting/maid'

export default {
  data() {
    return {
      labels: {
        fw: 'Foreign Domestic Worker',
        // fwTransNo: 'SB Transmission No.',
        fwTransNo: 'SB Transmission No. / Employer NRIC/FIN No.',
        fwTransNoInfo: 'Refers to your In-Principle Approval/Renewal Letter from MOM',
        fwName: 'Name as in Passport',
        fwNationality: 'Nationality',
        // fwPassport: 'Passport No.',
        fwPassport: 'Worker FIN No.',
        fwDob: 'Date of Birth',
        fwGender: 'Gender',
        fwWPNo: 'Work Permit No.',
        fwWPNoInfo: 'Refers to your In-Principle Approval/Renewal Letter from MOM',
        fwWPType: 'Work Permit Type'
      }
    }
  },
  computed: {
    maid() {
      return this.$store.state.agency.quotation.maidForm
    },
    gender() {
      if (this.maid.fwGender) {
        return gender[this.maid.fwGender]
      } else {
        return ' - '
      }
    },
    nationality() {
      if (this.maid.fwNationality) {
        return maidNationality[this.maid.fwNationality]
      } else {
        return ' - '
      }
    },
    workPermitType() {
      if (this.maid.fwWPType) {
        return workPermitType[this.maid.fwWPType]
      } else {
        return ' - '
      }
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    }
  }
}
</script>

<style>
</style>
